export const AVAILABLE_CROPS = ['corn', 'wheat', 'soy', 'barley'] as const;
export const MIN_ENVIRONMENT = 1000;
export const MAX_ENVIRONMENT = 15000;

/** Density range (seeds/ha) per crop — wheat and barley share the same range. */
export const DENSITY_RANGE_BY_CROP: Record<(typeof AVAILABLE_CROPS)[number], { min: number; max: number }> = {
    corn: { min: 30000, max: 120000 },
    soy: { min: 20000, max: 40000 },
    wheat: { min: 2500000, max: 4000000 },
    barley: { min: 2500000, max: 4000000 },
};

/** Falls back to corn's range while no crop is selected yet. */
export const getDensityRange = (crop: (typeof AVAILABLE_CROPS)[number] | 'other' | '' | undefined) =>
    DENSITY_RANGE_BY_CROP[crop as (typeof AVAILABLE_CROPS)[number]] ?? DENSITY_RANGE_BY_CROP.corn;

export type CropMonitoringFormType = {
    id: number | undefined;
    plantingDate: string | undefined;
    product: number | undefined | string;
    technology: number | undefined;
    environment: number | undefined;
    plantedArea: number | undefined;
    density: number | undefined;
    fieldId: number | undefined;
    crop: (typeof AVAILABLE_CROPS)[number] | '';
    previousCrop: (typeof AVAILABLE_CROPS)[number] | '' | 'none' | 'other';
};

export type FieldOption = {
    label: string;
    value: number;
};
